import { NotFoundError } from '@cian/peperrors';

import { sendMessage } from './sendMessage';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { retrySendFileMessage } from '../sendFileMessage/retrySendFileMessage';
import { sendOfferMessage } from '../sendOfferMessage';

export const retrySendMessageById =
  (currentChatId: string, messageId: string): TThunkAction<void> =>
  (dispatch, getState, { logger, custom: { messagesMap, socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents } = socket;

    const { openedChats } = getState();

    const currentChat = openedChats[currentChatId];

    if (!currentChat) {
      const exception = new NotFoundError({
        domain: EExceptionDomain.Messages,
        message: 'Не удалось повторно отправить сообщение, чат не найден',
        details: { currentChatId, messageId },
      });

      logger.error(exception);

      return;
    }

    const messageItem = messagesMap.get(messageId);

    if (!messageItem || messageItem.message.chatId !== currentChatId) {
      return;
    }

    const pendingFiles = currentChat.pendingFiles?.[messageId];

    if (messageItem.message.message.offers?.length) {
      clientEvents.delete(messageId);

      dispatch(sendOfferMessage({ chatId: currentChatId, offer: messageItem.message.message.offers[0], messageId }));

      return;
    }

    // Сообщение с одним фото-файлом в начальной реализации
    if (pendingFiles?.blobFiles?.length || pendingFiles?.uploadedFiles?.length) {
      clientEvents.delete(messageId);

      dispatch(retrySendFileMessage({ chatId: currentChatId, messageId, pendingFiles }));

      return;
    }

    clientEvents.delete(messageId);
    dispatch(sendMessage({ text: messageItem.message.message.message, chatId: currentChatId, messageId }));
  };
